import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import WifiTethering from '@material-ui/icons/WifiTethering';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { sortByName } from '../../../api/helpers';
//import { PERMISSIONS } from '../../api/ServerApi';



class NetworksList_ extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {menuAnchor: null, menuNetworkID: ''}


        this.handleStartClick = this.handleStartClick.bind(this)
        this.handleStopClick = this.handleStopClick.bind(this)
    }

    handleNetworkSelect(networkID){
        //console.log('select network '+networkID)
        this.props.onNetworkSelect(networkID)
    }

    getNetworkStyle(networkID){
        let selected = networkID === this.props.selectedNetworkID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, networkID){
        this.setState({menuAnchor: event.currentTarget, menuNetworkID: networkID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null, menuNetworkID: null});
        return null;
    }

    handleMenuItemClick(menu, netID){
        netID = netID ? netID : this.state.menuNetworkID
        this.handleMenuClose();
        this.props.onNetworkMenu(menu, netID)
    }

    handleStartClick(event, networkID){
        let action = {
            type: 'START_NETWORK',
            networkID: networkID
        }
        this.props.onAction(action)
        event.stopPropagation();
    }

    handleStopClick(event, networkID){
        let action = {
            type: 'STOP_NETWORK',
            networkID: networkID
        }
        this.props.onAction(action)
        event.stopPropagation();
    }

    checkPermission(permission){
        return this.props.onAction({
            type:'CHECK_PERMISSION', 
            networkID: this.state.menuNetworkID, 
            permission: permission 
        })
    }

    render(){
        const {t} = this.props

        this.props.networks.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        //console.log('this.props')
        //console.log(this.props)

        let filter = this.props.filter.toLowerCase()
        let networks = this.props.filter ? this.props.networks.filter(
            item => item.Name.toLowerCase().indexOf(filter) >= 0 
        ) : this.props.networks

        //console.log(networks)

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}></TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('Networks')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('State')}</TableCell>
                                <TableCell colSpan={2} style={styles.head}></TableCell>
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('NETWORK_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {networks.map((net) => 
                            <TableRow key={net.ID} 
                                    onClick={()=>{this.handleNetworkSelect(net.ID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('NETWORK_EDITOR_OPEN_EDIT', net.ID)}}
                                    style={this.getNetworkStyle(net.ID)}>

                                <TableCell style={{width:40}} component="th" scope="row">
                                  <WifiTethering color={net.IsRunning?"primary":"disabled"} />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                  {net.Name}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {t('CommandPort')}: {net.CommandPort},  {' '}
                                    {t('AudioPort')}: {net.AudioPort}, {' '}
                                    {t('VideoPort')}: {net.VideoPort}, {' '}
                                    {t('DeviceCount')}: {net.DeviceCount}
                                </TableCell>
                                
                                {/*
                                <TableCell>
                                  {net.CommandPort}
                                </TableCell>
                                <TableCell>
                                    {net.devices?net.devices.length:0}
                                </TableCell>
                                 */}
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        disabled={net.IsRunning}
                                        onClick={event=>this.handleStartClick(event, net.ID)}>
                                        <PlayArrow />
                                    </IconButton>
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        disabled={!net.IsRunning}
                                        onClick={event=>this.handleStopClick(event, net.ID)}>
                                        <Stop />
                                    </IconButton>
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        onClick={event=>this.handleMenuClick(event, net.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} 
                            onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('NETWORK_EDITOR_OPEN_EDIT')}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditNetwork')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('NETWORK_DELETE')}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteNetwork')} />
                            </MenuItem>
                            {/*<MenuItem onClick={()=>{this.handleMenuItemClick('properties')}}>Properties...</MenuItem>*/}
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const NetworksList = withTranslation()(NetworksList_);